import { QuestionnaireAnswerType } from 'components/Assessments/types'
import { SupervisoryReviewQuestionnaireItem } from './questionnaire'

export const SUPERVISORY_REVIEW_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE = {
  [SupervisoryReviewQuestionnaireItem.SUPERVISORY_REVIEW_ID_BADGE]: QuestionnaireAnswerType.STRING,
  [SupervisoryReviewQuestionnaireItem.SUPERVISORY_REVIEW_HONORING_RIGHTS]:
    QuestionnaireAnswerType.STRING,
  [SupervisoryReviewQuestionnaireItem.SUPERVISORY_REVIEW_EMERGENCY_PROTOCOL]:
    QuestionnaireAnswerType.STRING,
  [SupervisoryReviewQuestionnaireItem.SUPERVISORY_REVIEW_HYGIENE_PRECAUTIONS]:
    QuestionnaireAnswerType.STRING,
  [SupervisoryReviewQuestionnaireItem.SUPERVISORY_REVIEW_REPORTING_CHANGES]:
    QuestionnaireAnswerType.STRING,
  [SupervisoryReviewQuestionnaireItem.SUPERVISORY_REVIEW_GRIEVANCE_COMPLAINT]:
    QuestionnaireAnswerType.STRING,
  [SupervisoryReviewQuestionnaireItem.SUPERVISORY_REVIEW_POC_DOC_REVIEWED_WITH_CAREGIVER]:
    QuestionnaireAnswerType.STRING,
  [SupervisoryReviewQuestionnaireItem.SUPERVISORY_REVIEW_PPE_ACCESS]:
    QuestionnaireAnswerType.STRING,
  [SupervisoryReviewQuestionnaireItem.SUPERVISORY_REVIEW_SUPERVISION_OBSERVED]:
    QuestionnaireAnswerType.STRING,
  [SupervisoryReviewQuestionnaireItem.SUPERVISORY_REVIEW_TASK_OBSERVED]:
    QuestionnaireAnswerType.STRING,
  [SupervisoryReviewQuestionnaireItem.SUPERVISORY_REVIEW_PATIENT_STATUS]:
    QuestionnaireAnswerType.STRING,
  [SupervisoryReviewQuestionnaireItem.SUPERVISORY_REVIEW_COMMENTS]: QuestionnaireAnswerType.STRING,
  [SupervisoryReviewQuestionnaireItem.SUPERVISORY_REVIEW_EDUCATION_CAREGIVER_EDUCATION_TOPIC]:
    QuestionnaireAnswerType.STRING,
  [SupervisoryReviewQuestionnaireItem.SUPERVISORY_REVIEW_EDUCATION_EDUCATION_PROVIDED]:
    QuestionnaireAnswerType.STRING
}
